import storage from "../../utils/storage";
import tracking from '../../utils/tracking';
import Modal from '../../components/generic/modal';

const MAC_OS_X = "Mac OS X";
const WINDOWS = "Windows";

class SourcetreeDownload {
  platform: string;

  constructor(_componentRoot: HTMLElement, { macURL, windowsURL, enterpriseURL }) {
    this.platform = window.navigator.userAgent.match(/Mac/)
      ? MAC_OS_X
      : WINDOWS;

    for (let linkNode of document.querySelectorAll(".download-link")) {
      linkNode.addEventListener("click", this.onDownloadClick.bind(this));

      if (window.location.pathname.match(/\/enterprise/)) {
        linkNode.href = enterpriseURL;
      } else {
        linkNode.href = this.platform ? macURL : windowsURL;

        if (this.platform === WINDOWS) {
          // switch in-page button texts and links to Windows first
          if (linkNode.innerText.match(MAC_OS_X)) {
            linkNode.innerText = linkNode.innerText.replace(MAC_OS_X, WINDOWS);
            linkNode.href = windowsURL;
          } else if (linkNode.innerText.match(WINDOWS)) {
            linkNode.innerText = linkNode.innerText.replace(WINDOWS, MAC_OS_X);
            linkNode.href = macURL;
          } else {
            linkNode.href = windowsURL;
          }
        } else if (linkNode.innerText.match(WINDOWS)) {
          linkNode.href = windowsURL; // need to set the Windows download URL even on Macs
        }
      }
    }

    // for the download archives page, add modal opening listener for download links
    for (const archiveLink of document.querySelectorAll("tbody a")) {
      if (!archiveLink.href.match("html"))
        // avoid release notes links
        archiveLink.addEventListener("click", this.onDownloadClick.bind(this));
    }
  }

  onDownloadClick(e: MouseEvent) {
    e.preventDefault();

    let EULAAgreed = false;

    const fileUrl = e.currentTarget.href;
    const productPlatform = this.platform;

    const modal = new Modal({
      modalType: "download wpl",
      contentClickToHide: false
    });

    const modalContent = modal.$modalContent.get(0);
    modalContent.innerHTML = document.querySelector(
      "#download-view-modal"
    ).outerHTML;

    const downloadBtn = modalContent.querySelector("#eula-downloads-button");
    downloadBtn.addEventListener("click", () => {
      if (!EULAAgreed) return; // need to agree to EULA before download

      modal.hide();
      document.querySelector("#download-area").remove();
      document
        .querySelector("#post-download-area")
        .setAttribute("style", "display: block"); // show post download content

      tracking.trackEvent("Started Download", {
        productName: "SourceTree",
        productPlatform,

        fileName: fileUrl.slice(fileUrl.lastIndexOf("/") + 1),
        fileUrl
      });
    });

    const downloadBtnCls = downloadBtn.getAttribute("class");
    modalContent.querySelector("input").addEventListener("click", () => {
      if ((EULAAgreed = !EULAAgreed)) {
        // enable download button on EULA agreement
        downloadBtn.setAttribute(
          "class",
          downloadBtnCls.replace(/disabled/, "")
        );
        downloadBtn.setAttribute("href", fileUrl);
      } else {
        downloadBtn.setAttribute("class", `${downloadBtnCls} disabled`);
        downloadBtn.removeAttribute("href");
      }
    });

    modalContent
      .querySelector(".downloads-view__cancel")
      .addEventListener("click", modal.hide.bind(modal));

    modal.show();
  }
}

export default SourcetreeDownload;
